import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/landing/header/Header";

import BannerContent from "../components/banner/BannerContent";
import { useSelector } from "react-redux";
import PageWitchMenu from "../components/mui/page_witch_menu/PageWitchMenu";
import Footer from "../components/landing/footer/Footer";

export default function Banner() {
  const { id } = useParams();
  const banners = useSelector((state) => state.common.banners);

  const banner = banners.find((el) => el.relativeUrl == id);

  return (
    <PageWitchMenu className="banner-page">
      <Header />
      <BannerContent banner={banner} />
      <Footer />
    </PageWitchMenu>
  );
}
